import { render, staticRenderFns } from "./Apkmanage.vue?vue&type=template&id=216d095e&scoped=true&"
import script from "./Apkmanage.vue?vue&type=script&lang=js&"
export * from "./Apkmanage.vue?vue&type=script&lang=js&"
import style0 from "./Apkmanage.vue?vue&type=style&index=0&id=216d095e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d095e",
  null
  
)

export default component.exports